// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"8dbc90dc","942":"ac1954d4","1860":"08c81805","2053":"65e775b0","9515":"46005a0d"}[chunkId] + ".chunk.css";
};